<template>
    <div class="f-topic-header-sticky" id="sticky">
        <div class="f-topic-header-sticky-info">
            <div class="f-topic-header-sticky-info-word">
                <span class="f-topic-header-sticky-title"
                    @click="scrollToId('app')">
                    {{topicInfo.title}}
                </span>
            </div>
            <div class="f-topic-header-sticky-info-btn"
                @click="scrollToId('replyBottom')">快速回复</div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/topic-content.less';
</style>

<script>
import {mapState} from 'vuex';
import {fixBugs} from '../utils/bugs-fixed';
import {scrollToId} from '@/utils/decorate/scroll';
import {addEvent, removeEvent} from '@/utils/decorate/event';

export default {
    computed: {
        ...mapState({
            topicInfo: state => state.topicContent.topicData.topicInfo
        })
    },
    mounted() {
        addEvent(window, 'scroll', fixBugs);
    },
    destroyed() {
        removeEvent(window, 'scroll', fixBugs);
    },
    methods: {
        scrollToId,
        changeTopicLikeState() {
            this.$emit('like');
        }
    }
};
</script>
